import { render } from "./editTax.vue?vue&type=template&id=254eb79a&scoped=true"
import script from "./editTax.vue?vue&type=script&lang=js"
export * from "./editTax.vue?vue&type=script&lang=js"

import "./editTax.vue?vue&type=style&index=0&id=254eb79a&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-254eb79a"]])

export default __exports__